import {Component, Input, ElementRef, ViewChild} from "@angular/core";
import {MakeProvider} from "./abstract-value-accessor";
import {ControlValueAccessor} from '@angular/forms';

var Pikaday = require('pikaday');

@Component({
    selector : 'dk-date-input',
    template: '<input #input readonly="readonly" />',
    providers: [MakeProvider(DkDateInputComponent)]
})

export class DkDateInputComponent implements ControlValueAccessor {
    @Input()
    public disableWeekends: boolean = true;

    @Input()
    public suffix: string;

    @ViewChild('input') input: ElementRef;

    pikaday: any;

    writeValue(value: string) {
        this.pikaday.setDate(value, true);
    }

    onValueChange(value) {
        this.onChange(value);
    }

    onChange = (_) => {};
    onTouched = () => {};

    registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }

    registerOnTouched(fn: () => void): void { this.onTouched = fn; }

    constructor() {
    }

    public ngOnInit() {
        var self = this;

        this.pikaday = new Pikaday({
            field: this.input.nativeElement,
            format: 'YYYY-MM-DD',
            onSelect: function() {
                self.onValueChange(this.getMoment().format('YYYY-MM-DD'));
            },
            firstDay: 1,
            yearRange: [1900, 2050],
            disableWeekends: this.disableWeekends,
            i18n: {
                previousMonth : 'Poprzedni miesiąc',
                nextMonth     : 'Następny miesiąc',
                months        : ['Styczeń','Luty','Marzec','Kwiecień','Maj','Czerwiec','Lipiec','Sierpień','Wrzesień','Październik','Listopad','Grudzień'],
                weekdays      : ['Niedziela','Poniedziałek','Wtorek','Środa','Czwartek','Piątek','Sobota'],
                weekdaysShort : ['Nie','Pon','Wto','Śr','Czw','Pią','Sob']
            }
        });
    }
}